<app-data-grid
  [viewId]="viewId"
  [title]="title"
  [icon]="icon"
  gridClassName="auto-story-runs-grid"
  [columnDefs]="columnDefs"
  [fetchRows]="fetchRows"
></app-data-grid>
